// Polyfill TextEncoder for MS Edge
require('fast-text-encoding');

module.exports = {
  encode: function encode(string) {
    return new TextEncoder().encode(string);
  },
  decode: function decode(buffer) {
    return new TextDecoder().decode(buffer);
  }
};